import { useAccess } from '../../lib/useAccess';
import { RunnersSection } from '../agents';
import { TokensSettingsPage } from '../settings/tokens';

/**
 * Ustawienia → Tokeny i agenci (kompozycja Fali 5, `/ustawienia/tokeny`): tokeny osobiste MCP i instrukcja podłączenia
 * Claude Code (moduł tokenów) + „Komputery z runnerem” (moduł Agenci, slot `children`) — jedno miejsce na dostęp
 * agentów do Fravity OS. Bez modułu Agenci sekcji komputerów nie ma (te same dane są w Agenci → Komputery).
 */
export function TokensAndAgentsSettingsPage() {
  const access = useAccess();
  return (
    <TokensSettingsPage>
      {access.can('agents') && (
        <div className="mt-6">
          <RunnersSection />
        </div>
      )}
    </TokensSettingsPage>
  );
}
